import { Phone } from "lucide-react";
import { BRAND } from "@/lib/brand";
import WhatsappIcon from "@/components/WhatsappIcon";

export default function StickyCall() {
  const waUrl = `https://wa.me/${BRAND.whatsappRaw}?text=${encodeURIComponent(
    "Hi MHJ Prestige Transport — I'd like a quote."
  )}`;

  return (
    <div className="md:hidden fixed bottom-4 right-4 z-40 flex flex-col gap-3 items-end">
      <a
        href={waUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-whatsapp-button"
        className="inline-flex items-center gap-2 px-5 py-4 bg-[#25D366] text-black font-bold shadow-lg shadow-black/40 active:scale-95 transition-transform"
      >
        <WhatsappIcon className="w-4 h-4" />
        WhatsApp
      </a>
      <a
        href={`tel:${BRAND.phoneRaw}`}
        data-testid="sticky-call-button"
        className="inline-flex items-center gap-2 px-5 py-4 bg-[#E60000] text-white font-bold shadow-lg shadow-black/40 active:scale-95 transition-transform"
      >
        <Phone className="w-4 h-4" />
        Call now
      </a>
    </div>
  );
}
